export default __webpack_public_path__ + "static/media/Path3458.36837790.svg";